/* tslint:disable */
/* eslint-disable */
/**
 * documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  NotifyLockEvent,
} from '../models/index';

export interface GeneralApiDeleteTenantRequest {
    tenant: string;
    organization: string;
}

/**
 * 
 */
export class GeneralApi extends runtime.BaseAPI {

    /**
     */
    async deleteTenantRaw(requestParameters: GeneralApiDeleteTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling deleteTenant().'
            );
        }

        if (requestParameters['organization'] == null) {
            throw new runtime.RequiredError(
                'organization',
                'Required parameter "organization" was null or undefined when calling deleteTenant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/organization/{organization}`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))).replace(`{${"organization"}}`, encodeURIComponent(String(requestParameters['organization']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteTenant(tenant: string, organization: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTenantRaw({ tenant: tenant, organization: organization }, initOverrides);
    }

    /**
     */
    async swaggerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/swagger.json`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async swagger(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.swaggerRaw(initOverrides);
        return await response.value();
    }

}
